/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_NewInputs */

const vi_weighing_new = /** @type {(inputs: Weighing_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm phiếu cân`)
};

/**

* @param {Weighing_NewInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_new = /** @type {((inputs?: Weighing_NewInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_NewInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_new(inputs)
});